import type { IConfigArea, IIssue, ISelectedPoint } from '../../trusstor/index.js';

/** One of an issue's locations, typed as the issue carries it. */
export type IssueLocation = NonNullable<IIssue['locations']>[number];

/** An issue's location for one site area, with the points pinned on its floor
 *  plan (none: the whole area). */
export function toIssueLocation(area: IConfigArea, pins: readonly ISelectedPoint[] = []): IssueLocation {
  return {
    floor: { floorId: area.floorId, floorNick: area.floorNick },
    area:
      pins.length > 0
        ? {
            areaId: area.areaId,
            areaNick: area.areaNick,
            selectedPoints: pins.map(({ xPercentage, yPercentage }) => ({ xPercentage, yPercentage })),
          }
        : { areaId: area.areaId, areaNick: area.areaNick },
  };
}
